import { useEffect, useRef } from "react";

/**
 * Attaches an IntersectionObserver to the returned ref.
 * When the element enters the viewport, the "visible" class is added,
 * triggering the .fade-up CSS transition defined in GlobalStyles.css.
 *
 * @param {number} threshold  0–1, fraction of element visible before firing
 * @param {string} rootMargin e.g. "0px 0px -60px 0px" to fire slightly early
 */
export default function useFadeIn(
  threshold = 0.15,
  rootMargin = "0px 0px -50px 0px"
) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("visible");
          observer.unobserve(el); // fire once
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return ref;
}
